// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/bi/bi.actions.go

export const UPDATE_DASHBOARD = "mondoo.bi.BIDashboardService.UpdateDashboard";
